"use client";

import React, { useState, useCallback } from "react";
import { Check, X } from "lucide-react";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "./helpers/cropImage";
import "./AvatarCropper.css";

interface AvatarCropperProps {
  imageSrc: string;
  shape?: "circle" | "rounded";
  onCropDone: (croppedImage: string) => void;
  onCancel: () => void;
}

const AvatarCropper: React.FC<AvatarCropperProps> = ({
  imageSrc,
  shape = "circle",
  onCropDone,
  onCancel,
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);

  // Save cropped area on every crop action
  const onCropComplete = useCallback((_: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  // Generate the cropped image when user confirms
  const handleDone = async () => {
    const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels, "rounded"); // always crop square
    if (croppedImage) {
      onCropDone(croppedImage);
    }
  };

  return (
    <div className="avatar-cropper-container">
      <div className="cropper-wrapper">
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={1} // always crop square
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
          cropShape="rect" // always rectangular crop
          showGrid={false}
        />
        {/* Optional visual circle mask overlay */}
        {shape === "circle" && <div className="circle-mask-overlay" />}
      </div>

      <div className="cropper-controls">
        <input
          type="range"
          min={1}
          max={3}
          step={0.1}
          value={zoom}
          onChange={(e) => setZoom(+e.target.value)}
        />
      </div>

      <div className="cropper-buttons">

        <button
          type="button"
          className="cropper-btn cancel"
          onClick={onCancel}
          title="Cancel"
        >
          <X size={28} strokeWidth={5} />
        </button>
        <button
          type="button"
          className="cropper-btn confirm"
          onClick={handleDone}
          title="Crop"
        >
          <Check size={28} strokeWidth={5} />
        </button>
      </div>
    </div>
  );
};

export default AvatarCropper;
